module.exports = __webpack_public_path__ + "img/img7.37f59cac.png";